import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { useState, useEffect, lazy, Suspense } from "react";

// Lazy-load CookieConsent — non-critical, defer after first paint
const CookieConsent = lazy(() => import("./components/CookieConsent"));

function App() {
  // Mount CookieConsent only after the initial paint settles
  const [showCookieBanner, setShowCookieBanner] = useState(false);

  useEffect(() => {
    // Defer to after browser is idle / first paint completes
    const id = typeof requestIdleCallback !== 'undefined'
      ? requestIdleCallback(() => setShowCookieBanner(true), { timeout: 3000 })
      : window.setTimeout(() => setShowCookieBanner(true), 1500);
    return () => {
      if (typeof cancelIdleCallback !== 'undefined') {
        cancelIdleCallback(id as number);
      } else {
        clearTimeout(id as number);
      }
    };
  }, []);

  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <AppRoutes />
        {showCookieBanner && (
          <Suspense fallback={null}>
            <CookieConsent />
          </Suspense>
        )}
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
